interface LastUsedBadgeProps {
  label: string;
  /**
   * `subtle` (default) renders an indigo-tinted pill for light surfaces such as
   * the OAuth buttons. `onPrimary` renders a translucent white pill for use on
   * top of a filled primary (indigo) button.
   */
  variant?: 'subtle' | 'onPrimary';
}

/**
 * A small "Last used" pill that marks the auth method a returning user picked
 * last time. Positioned at the trailing edge of its (relatively positioned)
 * parent button.
 */
export default function LastUsedBadge({
  label,
  variant = 'subtle',
}: LastUsedBadgeProps) {
  const styles =
    variant === 'onPrimary'
      ? 'bg-white/20 text-white'
      : 'bg-primary-50 text-primary-700 dark:bg-primary-500/15 dark:text-primary-300';

  return (
    <span
      className={`pointer-events-none absolute right-3 top-1/2 inline-flex -translate-y-1/2 items-center rounded-full px-2 py-0.5 text-[11px] font-medium leading-none ${styles}`}
    >
      {label}
    </span>
  );
}
